import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import type { SingleSite, SiteMap } from "../types";
import * as machines from "./machines";
import * as ipJson from "./ipJson";
import { warn } from "../infra/effects";

export const createSitesApi = (
  db: MarlinStoreDb,
  capabilities: Pick<HostCapabilities, "files" | "syncIntegration">,
) => {
  const { files } = capabilities;
  return {
    getMachine: (id: number) => machines.getMachine(db, id),
    getAllSites: () => machines.getAllSites(db),
    getMachines: () => machines.getMachines(db),
    getMachinesLoaded: () => machines.getMachinesLoaded(db),
    removeMachine: (machineId: number) => machines.removeMachine(db, machineId),
    saveSite: async (site: SingleSite): Promise<SiteMap> => {
      const { sites, previous } = await machines.saveSite(db, site);
      const content = await ipJson.mirrorSiteIntoIpJson(db, site, previous);
      await files?.writeIpJson(content).catch(warn("ip.json write"));
      await capabilities
        .syncIntegration?.("site")
        .catch(warn("integration sync"));
      return sites;
    },
    removeSite: async (site: SingleSite): Promise<SiteMap> => {
      const content = await ipJson.removeSiteFromIpJson(db, site);
      const sites = await machines.removeSite(db, site);
      if (content)
        await files?.writeIpJson(content).catch(warn("ip.json write"));
      await capabilities
        .syncIntegration?.("site")
        .catch(warn("integration sync"));
      return sites;
    },
  };
};

export type SitesApi = ReturnType<typeof createSitesApi>;
